"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPayrollShiftNurseProfileDto = instanceOfPayrollShiftNurseProfileDto;
exports.PayrollShiftNurseProfileDtoFromJSON = PayrollShiftNurseProfileDtoFromJSON;
exports.PayrollShiftNurseProfileDtoFromJSONTyped = PayrollShiftNurseProfileDtoFromJSONTyped;
exports.PayrollShiftNurseProfileDtoToJSON = PayrollShiftNurseProfileDtoToJSON;
exports.PayrollShiftNurseProfileDtoToJSONTyped = PayrollShiftNurseProfileDtoToJSONTyped;
/**
 * Check if a given object implements the PayrollShiftNurseProfileDto interface.
 */
function instanceOfPayrollShiftNurseProfileDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('isSalaried' in value) || value['isSalaried'] === undefined)
        return false;
    return true;
}
function PayrollShiftNurseProfileDtoFromJSON(json) {
    return PayrollShiftNurseProfileDtoFromJSONTyped(json, false);
}
function PayrollShiftNurseProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'isSalaried': json['isSalaried'],
    };
}
function PayrollShiftNurseProfileDtoToJSON(json) {
    return PayrollShiftNurseProfileDtoToJSONTyped(json, false);
}
function PayrollShiftNurseProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'isSalaried': value['isSalaried'],
    };
}
//# sourceMappingURL=PayrollShiftNurseProfileDto.js.map